import { CivilStatusService } from "../../services/models/civilStatus";
const moduleCivilStatus = {
	namespaced: true,
	state: {
		civilStatuses: [],
		loading: false,
	},
	getters: {
		getCivilStatuses(state) {
			return state.civilStatuses;
		},
		getLoading(state) {
			return state.loading;
		}
	},
	mutations: {
		loadCivilStatuses(state, civilStatuses) {
			state.civilStatuses = civilStatuses;
		}
	},
	actions: {
		async loadCivilStatuses({ commit, state }) {
			state.loading = true;
			let civilStatuses = await CivilStatusService.getAll();
			commit("loadCivilStatuses", civilStatuses);
			state.loading = false;
		}
	}
}

export default moduleCivilStatus;